import { Fragment, useState } from "@wordpress/element";
import { Transition } from "@headlessui/react";

export function Flyout(props: { onSetup: Function, html: string }) {
  const [open, setOpen] = useState(false);

  props.onSetup({
    trigger() {
      setOpen(!open);
      return !open;
    }
  });

  return (
    <Transition
      show={open}
      as={Fragment}
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 -translate-y-1"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-1"
    >
      <div className="absolute left-2/4 -translate-x-2/4 z-20 transform shadow-lg mt-6">
        <div dangerouslySetInnerHTML={{__html: props.html}} />
      </div>
    </Transition>
  );
}
